// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3TStQ","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3XjPP","obliqueLine":"membershipbadge_obliqueLine__2SUiY"};